export default {
    data(){
        return{
            dropMenuStyle : {
                top:'40px',
                maxHeight : '50vh'
            }
        }
    },
    computed:{
        getMenu(){
            return this.$refs['dropMenu'];
        },
        getButton(){
            return this.$refs['dropButton'];
        },
        selectedItemCSS() {
            return ['rounded', 'bg-gray-200', 'text-bold']
        }
    },
    methods:{
        emitDropdownValue(value) {
            this.$emit('update:modelValue', value);
            this.$emit('update:value', value);
            this.$emit('input', value);
        },

        isSelected(item) {

            return this.value.filter((i) => {

                return i[this.valueKey] === item[this.valueKey];
            }).length > 0;
        },
        selectItem(item) {

            if(this.single){
                this.hiddenDropDownMenu();
                this.emitDropdownValue([item]);
            }
            this.getDropMenuStyle();
            this.emitDropdownValue(this.value.concat([item]));
        },
        toggleItem(item) {
            if (this.isSelected(item)) {

                this.unselectItem(item);

            } else {
                this.selectItem(item);
            }
        },
        unselectItem(item) {

            let items = this.value.filter((i) => {
                return i !== item;
            });
            this.emitDropdownValue(items);

            if( this.single ){
                this.showDropDownMenu();
                this.getDropMenuStyle();
            }
        },
        getDropMenuStyle() {


        },
        checkParent(t, elm) {
            while (t.parentNode) {
                if (t === elm) {
                    return true;
                }
                t = t.parentNode;
            }
            return false;
        },
        showDropDownMenu(){
            if(this.getMenu.classList.contains('hidden')){
                this.getMenu.classList.remove('hidden')
            }
        },
        hiddenDropDownMenu(){
            if(!this.getMenu.classList.contains('hidden')){
                this.getMenu.classList.add('hidden')
            }
        },
        documentClickEventHandler(e) {

            var target = (e && e.target);
            if ( this.checkParent(target, this.getMenu) ) {
                // 메뉴 안에 있는 타켓은 아무 것도 하지 않습니다.
                return ;
            }
            // 메뉴 밖에 있는 요소 중 버튼이라면 ?!
            if (this.checkParent(target, this.getButton)) {
                // 토글합니다.
                if (this.getMenu.classList.contains("hidden")) {
                    this.getMenu.classList.remove("hidden");
                } else {
                    this.getMenu.classList.add("hidden");
                }

                return ;
            }
            // 버튼외에 다른 요소라면 팝업을 가립니다.
            this.getMenu.classList.add("hidden");

        }
    },
    mounted() {
        this.getDropMenuStyle();
        document.addEventListener('click', this.documentClickEventHandler);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.documentClickEventHandler);
    }
}
